
<template>
  <div>
    <Header />
    <v-container>
      <v-row></v-row>
      <v-row justify="center" align="center" fill-height>
        <v-col cols="12" xl="8">
          <v-card :loading="loading">
            <v-container>
              <v-card-title>
                Schriftarten Verwaltung
                <v-spacer />
                  <v-btn color="primary" @click="addFont">Schriftart hinzufügen</v-btn>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-card class="ma-5" v-for="font in fonts" :key="font.id">
                    <v-container>
                      <v-row>
                        <v-col
                          cols="10"
                          style="font-size: 2em; line-height: 1.5em"
                          class="pa-5"
                          :style="{ fontFamily: font.name.replace(/\ /g, '')}"
                        >{{font.name}}</v-col>
                        <v-col>
                          <v-row>Externe ID: {{font.externalId}}</v-row>
                          <v-row>
                            <v-btn small color="primary" @click="editFont(font.id)">Bearbeiten</v-btn>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-container>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import FontService from "@/services/FontService";
import Header from "@/views/general/header";
import router from "@/plugins/router";

export default {
  name: "dashboard",
  components: {
    Header: Header
  },
  data: () => ({
    loading: true,
    fonts: []
  }),
  created() {},
  mounted() {
    this.refresh();
  },
  methods: {
    loadFont(font) {
      let fontFace = new FontFace(
        font.name.replace(/ /g, ""),
        "url('" + font.url + "')"
      );
      fontFace
        .load()
        .then(face => {
          document.fonts.add(face);
        })
        .catch(err => {
          throw err
        });
    },

    addFont() {
      router.push({ name: "FontsAdd" });
    },

    editFont(id) {
      router.push({ name: "FontsEdit", params: { id: id } });
    },
    async refresh() {
      this.loading = true;
      try {
        let data = (await FontService.getFonts()).data;
        if (data) {
          this.fonts = data.sort((a, b) =>
            a.externalId < b.externalId ? -1 : 0
          );

          for (let font of data) {
            this.loadFont(font);
          }
        } else {
          this.list = [];
        }
        this.loading = false;
      } catch (err) {
        if (err.response.status == 401) {
          router.replace("/auth/login");
        }
      }
    }
  }
};
</script>

